import { apiRequest } from './api'

export function listUsers() {
  return apiRequest('/auth/users', {
    method: 'GET',
  })
}

export function registerUser(payload) {
  return apiRequest('/auth/register', {
    method: 'POST',
    skipAuth: true,
    body: JSON.stringify(payload),
  })
}

export function updateUser(userId, payload) {
  return apiRequest(`/auth/users/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  })
}

export function deactivateUser(userId) {
  return apiRequest(`/auth/users/${userId}/deactivate`, {
    method: 'PATCH',
  })
}

export function deleteUser(userId) {
  return apiRequest(`/auth/users/${userId}`, {
    method: 'DELETE',
  })
}
